import {
  GoogleMap as BaseGoogleMap,
  useJsApiLoader,
  Marker,
} from "@react-google-maps/api";
import { Skeleton } from "@chakra-ui/skeleton";

interface BaseMapProps {
  apiKey: string;
  latitude: number;
  longitude: number;
  onCoordinatesChange?: (latitude: number, longitude: number) => void;
}

const containerStyle = {
  width: "100%",
  height: "360px",
};

function BaseMap({
  apiKey,
  latitude,
  longitude,
  onCoordinatesChange,
}: BaseMapProps) {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: apiKey,
    id: "google-map",
  });

  return isLoaded ? (
    <BaseGoogleMap
      mapContainerStyle={containerStyle}
      center={{
        lat: latitude,
        lng: longitude,
      }}
      zoom={18}
      onClick={(ev) => {
        const longitude = ev.latLng?.lng();
        const latitude = ev.latLng?.lat();

        if (Number.isFinite(longitude) && Number.isFinite(latitude)) {
          onCoordinatesChange?.(latitude!, longitude!);
        }
      }}
      clickableIcons={false}
      options={{
        streetViewControl: false,
        disableDefaultUI: true,
      }}
    >
      <Marker
        position={{
          lat: latitude,
          lng: longitude,
        }}
      />
    </BaseGoogleMap>
  ) : (
    <Skeleton w="100%" h="360px" />
  );
}

export default BaseMap;
